import { Service, ServiceField } from '@onlog-public/additional-services-types';
import { DefaultCustomsPaymentsProduct } from '@pages/AdditionalServices/components/Service/CustomsPaymentsTemplate/DefaultCustomsPaymentsProduct';
import { CustomsPaymentsTemplateStore } from '@pages/AdditionalServices/components/Service/CustomsPaymentsTemplate/types';
import { serviceStateGeneratorProcessor } from '@pages/AdditionalServices/containers/services/serviceStateGenerator/types';

/**
 * CustomsPaymentsTemplateProcessor создает базовый стейт для услуг типа "Таможенные платежи"
 */
export class CustomsPaymentsTemplateProcessor implements serviceStateGeneratorProcessor {
  /**
   * isAvailable проверяет доступность процессора для генерации
   * @param service
   */
  isAvailable(service: Service): boolean {
    return service.template === 'customsPayments';
  }

  /**
   * generate выполняет генерацию стейта по полям и услуге. Возвращает сам стейт.
   * @param _
   * @param __
   * @param ___
   * @param ____
   */
  generate(
    _: Service,
    __: ServiceField[],
    ___: { [x: string]: number },
    ____: CustomsPaymentsTemplateStore
  ) {
    const result: CustomsPaymentsTemplateStore = {
      products: [new DefaultCustomsPaymentsProduct()],
    };

    return result;
  }

  /**
   * restore выполняет генерацию стейта по полям, услуге и восстановленому стейту. Возвращает сам стейт.
   * @param _
   * @param __
   * @param ___
   * @param existStore
   */
  restore(
    _: Service,
    __: ServiceField[],
    ___: { [x: string]: number },
    existStore?: CustomsPaymentsTemplateStore
  ) {
    const result: CustomsPaymentsTemplateStore = {
      products: [...(existStore.products ?? [])],
    };

    return result;
  }
}
